import React, { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Toggle from "../../components/Toggle";
import { useAuth } from "../../context/AuthContextProvider";
import LoadingScreen from "../../components/LoadingScreen";
import { useNavigate } from "react-router-dom";
import NoDigitalInvoice from "./NoDigitalInvoice";
import { fetchAllInvoice } from "../../services/invoice";

const DigitalInvoice = () => {
  const [invoice, setInvoice] = useState([]);
  const [loading, setLoading] = useState(false);

  const { globalProfile } = useAuth();
  const navigate = useNavigate();

  const handleCreateInvoice = () => {
    navigate("/payments/digital-invoice/create-invoice");
  };

  const getAllInvoice = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetchAllInvoice();
      setInvoice(res.data || []);
      setLoading(false);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getAllInvoice();
  }, [getAllInvoice, globalProfile]);

  const handleProfile = (info) => {
    navigate(`/payments/digital-invoice/payment-invoice/${info.code}`);
  };

  if (loading) {
    return <LoadingScreen title="Payments - Digital Invoice" />;
  }

  if (invoice.length === 0) {
    return <NoDigitalInvoice />;
  }

  return (
    <div className="">
      <div className="flex flex-col xl:flex-row items-start justify-between">
        <h1 className="text-navy-blue text-2xl font-bold">
          Payments - Digital Invoice
        </h1>

        <div className="flex sm:flex-row flex-col justify-center items-center">
          <Toggle />
        </div>
      </div>
      <div className="xl:flex items-center justify-end mt-10">
        <div className="relative">
          <button
            onClick={handleCreateInvoice}
            className="text-white bg-primary w-[150px] lg:w-[165px] h-[42px] rounded-[10px] mb-3 md:mb-0"
          >
            Create Invoice
          </button>
        </div>
      </div>

      <div className="bg-white mr-5 md:mr-0 sm:mt-4 sm:ml-3 sm:px-7 sm:py-5">
        <div className="flex items-center sm:justify-between mb-4">
          <div className="flex flex-col-reverse sm:flex-row sm:items-center">
            <p className="border-r pr-4 text-sm font-bold text-black-shade">
              Digital Invoice
            </p>
          </div>
        </div>

        <DataTable
          value={invoice}
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 20]}
          emptyMessage="No invoices found."
          onRowClick={(e) => handleProfile(e.data)}
          rowClassName={() => "cursor-pointer hover:bg-gray-50 transition-colors"}
          className="p-datatable-sm"
          responsiveLayout="scroll"
        >
          <Column
            field="customerName"
            header="Customer Name"
            sortable
            body={(row) => <div className="py-2">{row.customerName || "-"}</div>}
          />
          <Column
            field="customerEmail"
            header="Customer Email"
            sortable
            body={(row) => <div className="py-2">{row.customerEmail || "-"}</div>}
          />
          <Column
            field="code"
            header="Code"
            sortable
            body={(row) => <div className="py-2 font-mono text-xs">{row.code}</div>}
          />
          <Column
            field="totalAmount"
            header="Total Amount"
            sortable
            body={(row) => (
              <div className="py-2">
                {row.currencySymbol || ""}{row.totalAmount != null ? Number(row.totalAmount).toLocaleString() : "-"}
              </div>
            )}
          />
          <Column
            field="invoiceDate"
            header="Invoice Date"
            sortable
            body={(row) => (
              <div className="py-2">
                {row.invoiceDate
                  ? new Date(row.invoiceDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })
                  : "-"}
              </div>
            )}
          />
          <Column
            field="dueDate"
            header="Due Date"
            sortable
            body={(row) => (
              <div className="py-2">
                {row.dueDate
                  ? new Date(row.dueDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })
                  : "-"}
              </div>
            )}
          />
          <Column
            field="invoiceNumber"
            header="Invoice Number"
            sortable
            body={(row) => <div className="py-2">{row.invoiceNumber || "-"}</div>}
          />
        </DataTable>
      </div>
    </div>
  );
};

export default DigitalInvoice;
